export const COMMON_NAME_PREFIXES = [
  "Dr.",
  "Prof.",
  "Mr.",
  "Mrs.",
  "Miss",
  "Ms.",
  "Mx.",
  "Rev.",
  "Fr.",
  "Sr.",
];

export function normaliseNamePrefix(value) {
  return String(value || "").trim().replace(/\s+/g, " ").slice(0, 32);
}

export function formatProfileName(profile, fallback = "Staff member") {
  if (!profile) return fallback;
  const name = String(profile.full_name || "").trim();
  if (!name) return fallback;

  const prefix = normaliseNamePrefix(profile.name_prefix);
  if (!prefix) return name;

  const lowerName = name.toLowerCase();
  const lowerPrefix = prefix.toLowerCase();
  if (lowerName === lowerPrefix || lowerName.startsWith(`${lowerPrefix} `)) return name;

  return `${prefix} ${name}`;
}
